export default __webpack_public_path__ + "static/media/Boots of Untamed Violence.fb0f0840.jpg";